import { create } from "zustand";

/**
 * Product Detail Modal Store
 *
 * Manages product detail modal state:
 * - Modal open/close state
 * - Product ID for modal content
 * - Modal actions
 */

interface ProductDetailModalStore {
  // State
  isOpen: boolean;
  productId: string | null;
  offerId: string | null;

  // Actions
  openModal: (productId: string, offerId?: string | null) => void;
  closeModal: () => void;
}

export const useProductDetailModalStore = create<ProductDetailModalStore>(
  (set) => ({
    // Initial state
    isOpen: false,
    productId: null,
    offerId: null,

    // Actions
    openModal: (productId: string, offerId = null) => {
      set({ isOpen: true, productId, offerId });
    },

    closeModal: () => {
      set({ isOpen: false, productId: null, offerId: null });
    },
  })
);
